import { DinamikBilesen } from '@service/fikoyt-ui/decorators/dinamik-bilesen';
import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { GameCardBase, GC_BASE_CSS } from '@/src/app/uygulamalar/hmi-pano/pano/game-card-base';
import { paramDeger } from '@/src/app/shared/utils/param-deger.utils';
import { FikoYTKokBilesenComponent } from '@/src/service/kok-bilesen/kok-bilesen.component';
import { BakimEditComponent } from './cam-bakim-edit.component';

const TUR_RENK: Record<string, string> = { 'Periyodik Bakım': '#52c41a', 'Arıza Bakım': '#ff4d4f', 'Revizyon': '#1890ff', 'Kalibrasyon': '#722ed1', 'Yağlama': '#fa8c16', 'Diğer': '#8c8c8c' };
const TUR_RGB: Record<string, string> = { 'Periyodik Bakım': '82,196,26', 'Arıza Bakım': '255,77,79', 'Revizyon': '24,144,255', 'Kalibrasyon': '114,46,209', 'Yağlama': '250,140,22', 'Diğer': '140,140,140' };

@Component({
  selector: 'cam-bakim-kart',
  standalone: true,
  imports: [CommonModule],
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <div class="gc gc--cam-bakim" [style.--accent]="renk()" [style.--accent-rgb]="rgb()" (mousemove)="mouseMove($event)" (mouseleave)="mouseLeave()" [ngStyle]="kartStil">
      <div class="gc-canli-bg"></div><div class="gc-parlak-kenar"></div>
      <div class="gc-kose gc-kose--sol-ust"></div><div class="gc-kose gc-kose--sag-ust"></div><div class="gc-kose gc-kose--sol-alt"></div><div class="gc-kose gc-kose--sag-alt"></div>
      <div class="gc-kose-ic gc-kose-ic--sol-ust"></div><div class="gc-kose-ic gc-kose-ic--sag-ust"></div><div class="gc-kose-ic gc-kose-ic--sol-alt"></div><div class="gc-kose-ic gc-kose-ic--sag-alt"></div>
      <div class="gc-rarity-serit"></div><div class="gc-ic-glow"></div><div class="gc-desen"></div><div class="gc-shimmer"></div><div class="gc-holo"></div>
      <div class="gc-kenar-glow" [style.background]="kenarGlow"></div>
      <div class="gc-icerik">
        <div class="gc-hud-baslik">🔧 BAKIM KAYDI</div>
        <div class="bk-baslik">{{ d('bakimTuru') || 'Tür Belirtilmedi' }}</div>
        @if (d('makineSaati')) { <div class="bk-saat">⏱ {{ d('makineSaati') }} saat</div> }
        @if (d('bakimci')) { <div class="bk-alt">👤 {{ d('bakimci') }}</div> }
        @if (d('yapilanIslem')) { <div class="bk-islem">{{ d('yapilanIslem') }}</div> }
        @if (sonrakiBakimStr()) { <div class="bk-sonraki">📅 Sonraki: {{ sonrakiBakimStr() }}</div> }
        <div class="gc-xp-bar"><div class="gc-xp-dolgu" [style.width.%]="gorunur() ? (d('yapilanIslem') ? 100 : 40) : 0"></div></div>
      </div>
    </div>
  `,
  styles: [GC_BASE_CSS, `
    .bk-baslik { font-size: 14px; font-weight: 700; color: var(--py-metin, #e2e8f0); white-space: nowrap; overflow: hidden; text-overflow: ellipsis; }
    .bk-saat { font-size: 12px; font-weight: 600; color: var(--accent); }
    .bk-alt { font-size: 11px; color: var(--py-metin-ikincil, #94a3b8); }
    .bk-islem { font-size: 10px; color: var(--py-metin-ucuncul, #64748b); white-space: nowrap; overflow: hidden; text-overflow: ellipsis; margin-top: 2px; }
    .bk-sonraki { font-size: 10px; color: var(--py-metin-ucuncul, #64748b); margin-top: 2px; }
  `],
})
export class BakimKartComponent extends GameCardBase {
  parametreler = input<any>();
  _hesap = input<any>();
  constructor() { super(); }
  d(ismi: string) { return paramDeger(this.parametreler()?.ek, ismi); }
  renk = computed(() => TUR_RENK[this.d('bakimTuru')] || '#52c41a');
  rgb = computed(() => TUR_RGB[this.d('bakimTuru')] || '82,196,26');
  sonrakiBakimStr = computed(() => {
    const t = this.d('sonrakiBakim');
    if (!t) return '';
    try { return new Date(t).toLocaleDateString('tr-TR'); } catch { return ''; }
  });
}

@Component({
  selector: 'cam-bakim-kart-sade',
  standalone: true,
  imports: [CommonModule],
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <div class="sk" style="--sk-accent:#52c41a">
      <div class="sk-icerik">
        <div class="sk-baslik">🔧 {{ d('bakimTuru') || 'Tür Belirtilmedi' }}</div>
        @if (d('bakimci')) { <div class="sk-alt">👤 {{ d('bakimci') }}</div> }
      </div>
      <div class="sk-sag">
        @if (d('makineSaati')) { <span style="font-size:12px;font-weight:600;color:var(--py-metin,#333)">{{ d('makineSaati') }} sa.</span> }
        <span class="sk-chip" [style.border-color]="turRenk()" [style.color]="turRenk()">{{ d('bakimTuru') || 'Belirsiz' }}</span>
      </div>
    </div>
  `,
})
export class BakimKartSadeComponent extends FikoYTKokBilesenComponent {
  parametreler = input<any>();
  constructor() { super(); }
  p = computed(() => this.parametreler()?.ek || {});
  d(alan: string): any { return paramDeger(this.p(), alan); }
  turRenk = computed(() => TUR_RENK[this.d('bakimTuru')] || '#52c41a');
}

@DinamikBilesen({
  id: 'cam-bakim',
  baslik: 'Bakım Kaydı',
  aciklama: 'Makine bakım kaydı takibi',
  ikon: 'tool',
  kategori: 'cam-isleme',
})
class CamBakim {
  paylas_kutusu = BakimEditComponent;
  paylasilmis_kart = BakimKartComponent;
  paylasilmis_kart_sade = BakimKartSadeComponent;
}
